import { render, staticRenderFns } from "./20201203.vue?vue&type=template&id=a44b9efa&lang=pug&"
var script = {}
import style0 from "./20201203.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a44b9efa')) {
      api.createRecord('a44b9efa', component.options)
    } else {
      api.reload('a44b9efa', component.options)
    }
    module.hot.accept("./20201203.vue?vue&type=template&id=a44b9efa&lang=pug&", function () {
      api.rerender('a44b9efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/blog/20201203.vue"
export default component.exports